import { useEffect } from 'react';

interface SeoJsonLdProps {
  data: object;
}

export default function SeoJsonLd({ data }: SeoJsonLdProps) {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(data);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [data]);

  return null;
}
